<template>
  <v-container class="pa-0">
    <v-row justify="end"
           align="center">
      <v-dialog v-model="alertDialog"
                :width="widthDialog">

        <!-- inicio de alerta de celo -->
        <v-stepper v-model="heatStep"
                   v-if="flagHeat">
          <v-stepper-header class="Alerts-stepperHeader">
            <v-stepper-step :complete="heatStep > 1" step="1"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="heatStep > 2" step="2"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="heatStep > 3" step="3"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="heatStep > 4" step="4"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="heatStep > 5" step="5"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- inicio de confirmación de celo (paso 1)-->
            <v-stepper-content step="1" class="std-text-md">
              <v-row no-gutters
                     class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de celo</div>
                  <div class="col-12 pa-0 mb-2"
                       :class="{'std-text-red-1': !heatNtn}"
                       v-html="htSub">
                  </div>
                  <div class="col-12 pa-0">¿Quieres confirmar el celo?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="closeDialog()">
                  <BackButton>
                  </BackButton>
                </v-col>
                <v-col cols="4" @click="notHeat()">
                  <WarnButton text="No entró en celo">
                  </WarnButton>
                </v-col>
                <v-col cols="3" @click="confirmHeat()">
                  <WarnButton text="Confirmar"
                              color="#65D9AC">
                  </WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de confirmación de celo (paso 1)-->

            <!-- inicio de celo limpio (paso 2) -->
            <v-stepper-content step="2">
              <v-row no-gutters class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de celo</div>
                  <div class="col-12 pa-0 mb-2">Estás registrando que la vaca <b>{{id}}</b> entró en celo.</div>
                  <div class="col-12 pa-0">¿Fue este un celo limpio?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="backFromTwoHeat()">
                  <BackButton>
                  </BackButton>
                </v-col>
                <v-col cols="3"
                       @click="isClean(false)">
                  <WarnButton text="No">
                  </WarnButton>
                </v-col>
                <v-col cols="3"
                       @click="isClean(true)">
                  <WarnButton text="Si"
                              color="#65D9AC">
                  </WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de celo limpio (paso 2) -->

            <!-- inicio de inseminación y tratamiento (paso 3) -->
            <v-stepper-content step="3">
              <div v-if="heatAlert.clean">
                <v-row no-gutters class="mb-6">
                  <v-col cols="12"
                         class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                    <div class="font-weight-bold col-12 pa-0 mb-4">Registro de celo</div>
                    <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> entró en celo y este <b>fue limpio</b>.</div>
                    <div class="col-12 pa-0">¿La inseminaste?</div>
                  </v-col>
                </v-row>
                <v-row no-gutters
                       class="px-2"
                       justify="space-between">
                  <v-col cols="3" @click="backFromThreeHeat()">
                    <BackButton>
                    </BackButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasInseminated(false)">
                    <WarnButton text="No">
                    </WarnButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasInseminated(true)">
                    <WarnButton text="Si"
                                color="#65D9AC">
                    </WarnButton>
                  </v-col>
                </v-row>
              </div>
              <div v-if="heatAlert.clean === false">
                <v-row no-gutters class="mb-6">
                  <v-col cols="12"
                         class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                    <div class="font-weight-bold col-12 pa-0 mb-4">Registro de celo</div>
                    <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> entró en celo y este <b>no fue limpio</b>.</div>
                    <div class="col-12 pa-0">¿Se le dió tratamiento?</div>
                  </v-col>
                </v-row>
                <v-row no-gutters
                       class="px-2"
                       justify="space-between">
                  <v-col cols="3" @click="backFromThreeHeat()">
                    <BackButton>
                    </BackButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasTreatment(false)">
                    <WarnButton text="No">
                    </WarnButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasTreatment(true)">
                    <WarnButton text="Si"
                                color="#65D9AC">
                    </WarnButton>
                  </v-col>
                </v-row>
              </div>
            </v-stepper-content>
            <!-- fin de inseminación y tratamiento(paso 3) -->

            <!-- inicio de periodo de espera voluntaria (paso 4) -->
            <v-stepper-content step="4">
              <div v-if="casePEVFStep">
                <v-row no-gutters class="mb-6">
                  <v-col cols="12"
                         class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                    <div class="font-weight-bold col-12 pa-0 mb-4">Registro de celo</div>
                    <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> entró en celo, este <b>fue limpio</b> y no la inseminaste.</div>
                    <div class="col-12 pa-0">¿Se encuentra en periodo de espera voluntario?</div>
                  </v-col>
                </v-row>
                <v-row no-gutters
                       class="px-2"
                       justify="space-between">
                  <v-col cols="3" @click="backFromFourHeat()">
                    <BackButton>
                    </BackButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasPEV(false)">
                    <WarnButton text="No">
                    </WarnButton>
                  </v-col>
                  <v-col cols="3"
                         @click="wasPEV(true)">
                    <WarnButton text="Si"
                                color="#65D9AC">
                    </WarnButton>
                  </v-col>
                </v-row>
              </div>
            </v-stepper-content>
            <!-- fin de periodo de espera voluntaria (paso 4) -->

            <!-- inicio de pantalla final (paso 5)-->
            <v-stepper-content step="5"
                               class="std-text-md std-text-blue-2 pr-8">

              <!-- inicio de pantalla, no entró en celo -->
              <div v-if="flagNotHeat">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">No entró en celo.</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu v-model="alertDatePicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      hide-details
                                      dense
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="alertDate"
                                    no-title
                                    @input="alertDatePicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="heatDescription"
                            v-model="heatAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3" @click="resetHeatAlert()">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(1)">
                        <WarnButton text="Registrar evento"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, no entró en celo -->

              <!-- inicio de pantalla, celo sucio con medicación -->
              <div v-if="caseDirtyMed">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">Celo sucio con medicación.</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu v-model="alertDatePicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      hide-details
                                      dense
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="alertDate"
                                    no-title
                                    @input="alertDatePicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="heatDescription"
                            v-model="heatAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="heatStep -= 2">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(2)">
                        <WarnButton text="Registrar evento"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, celo sucio con medicación -->

              <!-- inicio de pantalla, celo sucio sin medicación -->
              <div v-if="caseDirtyWMed">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">Celo sucio sin medicación.</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu v-model="alertDatePicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      hide-details
                                      dense
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="alertDate"
                                    no-title
                                    @input="alertDatePicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="heatDescription"
                            v-model="heatAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="heatStep -= 2">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(3)">
                        <WarnButton text="Registrar evento"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, celo sucio sin medicación -->

              <!-- inicio de pantalla, periodo de espera -->
              <div v-if="casePEV">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">No se inseminó por tiempo de espera.</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu v-model="alertDatePicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      hide-details
                                      dense
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="alertDate"
                                    no-title
                                    @input="alertDatePicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="heatDescription"
                            v-model="heatAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="heatStep--">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(4)">
                        <WarnButton text="Registrar evento"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, periodo de espera -->

              <!-- inicio de pantalla, inseminó correctamente -->
              <div v-if="caseInseminated">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">Se inseminó a la vaca correctamente.</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu v-model="alertDatePicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      hide-details
                                      dense
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="alertDate"
                                    no-title
                                    @input="alertDatePicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="heatDescription"
                            v-model="heatAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12"
                         class="mb-6">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Toro utilizado</div>
                        <div class="col-10 pa-0">
                          <v-select
                                  :items="bulls"
                                  item-value="idInternal"
                                  item-text="idInternal"
                                  dense
                                  hide-details
                                  v-model="heatAlert.bull"
                                  placeholder="Toro increíble"
                                  outlined>
                          </v-select>
                        </div>
                      </v-col>
                      <v-col cols="6" class="d-flex justify-end">
                        <div class="col-8 pa-0"
                             style="margin-top: 27px;">
                          <v-btn color="#FFFFFF"
                                 class="btn-add"
                                 @click="bullDialog = true"
                                 depressed
                                 height="40px"
                                 block>
                            <div class="d-flex align-center justify-center">
                              <div class="mr-2">Agregar toro</div>
                              <v-icon color="#65D9AC" large>mdi-plus-circle</v-icon>
                            </div>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="heatStep -= 2">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(5)">
                        <WarnButton text="Registrar evento"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, inseminó correctamente -->

              <!-- inicio de pantalla, celo perdido -->
              <div v-if="caseAlert">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de celo
                  </v-col>
                  <v-col cols="12"
                         class="d-flex justify-center mb-4">
                    <div class="col-12 pa-0 text-center std-text-red-1">¡Recuerda que es importante que insemines
                      las vacas que hayas observado en celo!
                    </div>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex justify-center mb-4 flex-wrap">
                    <div class="col-12 pa-0 text-center mb-4">¿Pero qué ha pasado? Nos informas que la vaca
                      <b>{{id}}</b> tuvo un <b>celo que {{clean}} fue limpio</b> y <b>{{inseminated}} la inseminaste</b>.
                    </div>
                    <div class="col-12 pa-0 text-center">¡Recuerda que cada celo es una oportunidad para
                      inseminar tus vacas y ganar dinero con ello!
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="heatStep--">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchHeat(6)">
                        <WarnButton text="Entendido">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de pantalla, celo perdido -->

            </v-stepper-content>
            <!-- fin de pantalla final (paso 5) -->

          </v-stepper-items>
        </v-stepper>
        <!-- fin de alerta de celo -->

        <!-- inicio de alerta de gestación -->
        <v-stepper v-model="gestationStep"
                   v-if="flagGestation">
          <v-stepper-header class="Alerts-stepperHeader">
            <v-stepper-step :complete="gestationStep > 1"
                            step="1"></v-stepper-step>
            <v-divider>
            </v-divider>
            <v-stepper-step :complete="gestationStep > 2"
                            step="2">
            </v-stepper-step>
            <v-divider>
            </v-divider>
            <v-stepper-step :complete="gestationStep > 3"
                            step="3">
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- inicio confirmación de preñez, pantalla 1 -->
            <v-stepper-content step="1">
              <v-row no-gutters
                     class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de preñez</div>
                  <div class="col-12 pa-0 mb-2"
                       :class="{'std-text-red-1': ptCheck}"
                       v-html="ptSub">
                  </div>
                  <div class="col-12 pa-0">¿Quieres confirmar su preñez?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="4" @click="closeDialog">
                  <BackButton>
                  </BackButton>
                </v-col>
                <v-col cols="4" @click="wasPregnant(false)">
                  <WarnButton text="No está preñada">
                  </WarnButton>
                </v-col>
                <v-col cols="3" @click="wasPregnant(true)">
                  <WarnButton text="Confirmar"
                              color="#65D9AC">
                  </WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de confirmación de preñez, pantalla 1  -->

            <!-- inicio confirmación de preñez, pantalla 2 -->
            <v-stepper-content step="2">
              <v-row no-gutters
                     class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de preñez</div>
                  <div class="col-12 pa-0 mb-2">Estás confirmando que la vaca {{id}}
                    <span v-if="!gestationAlert.isPregnant">no</span> quedó preñada.
                  </div>
                  <div class="col-12 pa-0">¿Que método usaste para el diagnóstico?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="4" @click="backFromTwoPregnant()">
                  <BackButton>
                  </BackButton>
                </v-col>
                <v-col cols="4" @click="whichMethodGestation('ultrasound')">
                  <WarnButton text="Ultrasonido">
                  </WarnButton>
                </v-col>
                <v-col cols="3" @click="whichMethodGestation('touch')">
                  <WarnButton text="Tacto"
                              color="#65D9AC">
                  </WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin confirmación de preñez, pantalla 2 -->

            <!-- inicio de guardar preñez (paso 3) -->
            <v-stepper-content step="3"
                               class="std-text-md std-text-blue-2 pr-8">
              <v-row no-gutters>
                <v-col cols="12"
                       class="d-flex justify-center font-weight-bold mb-8">Registro de preñez
                </v-col>
                <v-col cols="12"
                       class="mb-4">
                  <v-row no-gutters>
                    <v-col cols="6">
                      <div class="col-12 pa-0 font-weight-bold">Diagnóstico a registrar</div>
                      <div class="col-12 pa-0 std-text-gray-3 pr-2">{{getPregName()}}</div>
                    </v-col>
                    <v-col cols="6">
                      <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                      <div class="col-12 pa-0">
                        <v-menu
                                v-model="gestationAlertPicker"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                    :value="formattedGestationAlertDate"
                                    append-icon="mdi-calendar-blank"
                                    :rules="genericRules"
                                    outlined
                                    readonly
                                    dense
                                    hide-details
                                    v-on="on"
                            ></v-text-field>
                          </template>
                          <!--:allowed-dates="allowedReproductiveStagesDates"-->
                          <v-date-picker
                                  v-model="gestationAlert.date"
                                  no-title
                                  @input="gestationAlertPicker = false"
                                  locale="es-419">
                          </v-date-picker>
                        </v-menu>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12"
                       class="d-flex flex-wrap mb-4">
                  <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                  <v-textarea
                          class="form-text-input"
                          outlined
                          :placeholder="gestationDescription"
                          v-model="gestationAlert.description"
                          required>
                  </v-textarea>
                </v-col>
                <!--<v-row justify="center" align="center">
                  <v-col md="10">
                    <h3 class="Alert-blueQuestionFinal">Cambios por preñez</h3>
                  </v-col>
                  <v-col md="10" class="pt-0 pb-0 alerts-pregnant-changes">
                    <v-row>
                      <v-col class="alerts-checkbox-container" col="4">
                        <v-checkbox
                                v-model="checkDiet"
                                label="Dieta"
                        ></v-checkbox>
                      </v-col>
                      <v-col col="6" class="alerts-auto-container">
                        <v-autocomplete
                                class="alerts-autocomplete"
                                v-model="gestationAlert.diet"
                                :disabled="!checkDiet"
                                :items="items"
                                outlined
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col md="10" class="pt-0 pb-0 alerts-pregnant-changes">
                    <v-row>
                      <v-col class="alerts-checkbox-container" col="4">
                        <v-checkbox
                                v-model="checkGroup"
                                label="Potrero"
                        ></v-checkbox>
                      </v-col>
                      <v-col col="6" class="alerts-auto-container">
                        <v-autocomplete
                                :disabled="!checkGroup"
                                class="alerts-autocomplete"
                                v-model="gestationAlert.group"
                                :items="groups"
                                item-text="name"
                                :placeholder="group"
                                outlined
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>-->
                <v-col cols="12">
                  <v-row no-gutters
                         justify="space-between">
                    <v-col cols="5"
                           @click="backFromThreePregnant()">
                      <BackButton>
                      </BackButton>
                    </v-col>
                    <v-col cols="5"
                           v-if="caseTouchSuccess"
                           @click="dispatchPreg(1)">
                      <WarnButton text="Registrar evento"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                    <v-col cols="5"
                           v-if="caseTouchNot"
                           @click="dispatchPreg(2)">
                      <WarnButton text="Registrar evento"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                    <v-col cols="5"
                           v-if="caseUltraSuccess"
                           @click="dispatchPreg(3)">
                      <WarnButton text="Registrar evento"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                    <v-col cols="5"
                           v-if="caseUltraNot"
                           @click="dispatchPreg(4)">
                      <WarnButton text="Registrar evento"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de guardar preñez (paso 3) -->
          </v-stepper-items>
        </v-stepper>
        <!-- fin de alerta de gestación -->

        <!-- inicio de alerta de parto -->
        <v-stepper v-model="birthStep"
                   v-if="flagBirth">
          <v-stepper-header class="Alerts-stepperHeader">
            <v-stepper-step :complete="birthStep > 1"
                            step="1">
            </v-stepper-step>
            <v-divider>
            </v-divider>
            <v-stepper-step :complete="birthStep > 2"
                            step="2">
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>

            <!-- inicio de confirmación (pantalla 1) -->
            <v-stepper-content step="1"
                               class="std-text-md">
              <v-row no-gutters
                     class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de parto</div>
                  <div class="col-12 pa-0 mb-2">Estás confirmando el parto de la vaca <b>{{this.id}}</b>.
                  </div>
                  <div class="col-12 pa-0">¿El parto fue exitoso?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="closeDialog()">
                  <BackButton>
                  </BackButton>
                </v-col>
                <v-col cols="3" @click="wasAbort(true)">
                  <WarnButton text="No, abortó">
                  </WarnButton>
                </v-col>
                <v-col cols="3" @click="wasAbort(false)">
                  <WarnButton text="Exitoso"
                              color="#65D9AC">
                  </WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de confirmación (pantalla 1) -->

            <v-stepper-content step="2" class="std-text-md std-text-blue-2">
              <!-- inicio de exitoso (pantalla 2) -->
              <div v-if="caseBirth">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="d-flex justify-center font-weight-bold mb-8">Registro de parto
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Evento a registrar</div>
                        <div class="col-12 pa-0 std-text-gray-3 pr-2">Parto exitoso</div>
                      </v-col>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                        <div class="col-12 pa-0">
                          <v-menu
                                  v-model="gestationAlertPicker"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                      :value="formattedBirthAlertDate"
                                      append-icon="mdi-calendar-blank"
                                      :rules="genericRules"
                                      outlined
                                      dense
                                      hide-details
                                      readonly
                                      v-on="on"
                              ></v-text-field>
                            </template>
                            <!--:allowed-dates="allowedReproductiveStagesDates"-->
                            <v-date-picker
                                    v-model="birthAlert.date"
                                    no-title
                                    @input="gestationAlertPicker = false"
                                    locale="es-419">
                            </v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="birthDescription"
                            v-model="birthAlert.description"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="backFromTwoBirth()">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchBirth()">
                        <WarnButton text="Registrar parto"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de exitoso (pantalla 2) -->

              <!-- inicio de aborto (pantalla 2) -->
              <div v-if="caseAbort">
                <v-row no-gutters>
                  <v-col cols="12"
                         class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                    <div class="font-weight-bold col-12 pa-0 mb-4">Registro de aborto</div>
                    <div class="col-12 pa-0 mb-4">Estás confirmando que la vaca <b>{{this.id}}</b> abortó.
                    </div>
                  </v-col>
                  <v-col cols="12"
                         class="mb-4">
                    <v-row no-gutters>
                      <v-col cols="6">
                        <div class="col-12 pa-0 font-weight-bold text-center mb-2">Tipo de aborto</div>
                        <div class="col-12 pa-0 d-flex justify-center font-weight-bold flex-wrap">
                          <v-hover v-slot:default="{ hover }">
                            <div class="col-8 mb-4 std-border-radius d-flex align-center al-abort-card"
                                 :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && birthAlert.abortType !== 'nat'}"
                                 @click="abortTypeSet('nat')">
                              Natural
                            </div>
                          </v-hover>
                          <v-hover v-slot:default="{ hover }">
                            <div class="col-8 mb-4 std-border-radius d-flex align-center al-abort-card"
                                 :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && birthAlert.abortType !== 'ind'}"
                                 @click="abortTypeSet('ind')">
                              Inducido
                            </div>
                          </v-hover>
                        </div>
                      </v-col>
                      <v-fade-transition mode="out-in">
                        <v-col cols="6" v-if="birthAlert.abortType !== null">
                          <div class="col-12 pa-0 font-weight-bold text-center mb-2">Causa de aborto</div>
                          <div class="col-12 pa-0 d-flex justify-center font-weight-bold flex-wrap">
                            <v-hover v-slot:default="{ hover }">
                              <div class="col-8 mb-4 std-border-radius d-flex align-center al-abort-card"
                                   v-if="birthAlert.abortType === 'ind'"
                                   :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && birthAlert.abortReason !== 'acc'}"
                                   @click="abortReasonSet('acc')">
                                Accidente
                              </div>
                            </v-hover>
                            <v-hover v-slot:default="{ hover }">
                              <div class="col-8 mb-4 std-border-radius d-flex align-center al-abort-card"
                                   v-if="birthAlert.abortType === 'ind'"
                                   :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && birthAlert.abortReason !== 'sick'}"
                                   @click="abortReasonSet('sick')">
                                Enfermedad
                              </div>
                            </v-hover>
                            <div class="col-8 pa-0 font-weight-regular"
                                 v-if="birthAlert.abortType === 'nat'">
                              <v-autocomplete
                                      placeholder="Hormonal"
                                      v-model="birthAlert.abortReason"
                                      hide-details
                                      dense
                                      :items="abortCauses"
                                      outlined
                              ></v-autocomplete>
                            </div>
                          </div>
                        </v-col>
                      </v-fade-transition>
                      <div class="col-6 pa-0 mb-2"
                           v-if="birthAlert.abortReason === 'sick'">
                        <div class="col-12 pa-0 font-weight-bold mb-2">Enfermedad relacionada</div>
                        <v-autocomplete
                                v-model="birthAlert.abortSick"
                                dense
                                hide-details
                                :items="abortSicks"
                                :placeholder="abortSicks[0]"
                                outlined
                        ></v-autocomplete>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="12"
                         class="d-flex flex-wrap mb-4">
                    <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                    <v-textarea
                            class="form-text-input"
                            outlined
                            :placeholder="birthDescription"
                            required>
                    </v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-row no-gutters
                           justify="space-between">
                      <v-col cols="3"
                             @click="backFromTwoBirth()">
                        <BackButton>
                        </BackButton>
                      </v-col>
                      <v-col cols="4"
                             @click="dispatchBirth()">
                        <WarnButton text="Registrar aborto"
                                    color="#65D9AC">
                        </WarnButton>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <!-- fin de aborto (pantalla 2) -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <!-- fin de alerta de parto -->

        <!-- inicio de alerta de salud -->
        <v-stepper v-model="healthStep"
                   v-if="flagSick">
          <v-stepper-header class="Alerts-stepperHeader">

            <v-stepper-step :complete="heatStep > 1" step="1">
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="heatStep > 2" step="2"
            ></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items class="std-text-md std-text-blue-2">
            <!-- inicio de suceso (pantalla 1) -->
            <v-stepper-content step="1">
              <v-row no-gutters
                     v-if="!this.healthActive">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Registro de evento de salud</div>
                  <div class="col-12 pa-0 mb-4">¡¿Pero qué ha pasado con la vaca <b>{{this.id}}</b>?!
                  </div>
                </v-col>
                <v-col cols="12"
                       class="mb-1">
                  <v-row no-gutters class="justify-space-around">
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type !== 'acc'}"
                             @click="healthTypeSet('acc')">
                          Accidente
                        </div>
                      </v-hover>
                    </v-col>
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type !== 'diet'}"
                             @click="healthTypeSet('diet')">
                          Cambio de dieta
                        </div>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12"
                       class="mb-4">
                  <v-row no-gutters class="justify-space-around align-center">
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type  !== 'sick'}"
                             @click="healthTypeSet('sick')">
                          Enfermedad
                        </div>
                      </v-hover>
                    </v-col>
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type !== 'hltr'}"
                             @click="healthTypeSet('hltr')">
                          Tratamiento médico
                        </div>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters
                         justify="space-between">
                    <v-col cols="3"
                           @click="closeDialog()">
                      <BackButton>
                      </BackButton>
                    </v-col>
                    <v-col cols="4"
                           @click="healthStep = 2">
                      <WarnButton text="Confirmar"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters
                     v-else>
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Seguimiento de tratamiento</div>
                  <div class="col-12 pa-0 mb-4">¿Qué noticias tienes del animal <b>{{this.id}}</b>?
                  </div>
                </v-col>
                <v-col cols="12"
                       class="mb-1">
                  <v-row no-gutters class="justify-space-around">
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type !== 'scs'}"
                             @click="healthTypeSet('scs')">
                          Tratamiento exitoso
                        </div>
                      </v-hover>
                    </v-col>
                    <v-col cols="5">
                      <v-hover v-slot:default="{ hover }">
                        <div class="col-12 mb-4 std-border-radius d-flex align-center al-abort-card"
                             :class="{'std-container-shadow-dense': hover, 'std-disabled': !hover && healthAlert.type !== 'chg'}"
                             @click="healthTypeSet('chg')">
                          Cambio de tratamiento
                        </div>
                      </v-hover>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters
                         justify="space-between">
                    <v-col cols="3"
                           @click="closeDialog()">
                      <BackButton>
                      </BackButton>
                    </v-col>
                    <v-col cols="4"
                           @click="healthSuccess()">
                      <WarnButton text="Registrar"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de suceso (pantalla 1) -->

            <!-- inicio de registro accidente, enfermedad (pantalla 2) -->
            <v-stepper-content step="2">
              <v-row no-gutters>
                <v-col cols="12"
                       class="d-flex justify-center font-weight-bold mb-4">{{ healthTitle }}
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters
                         v-if="dietTreatment">
                    <v-col cols="12"
                           class="mb-4">
                      <v-row no-gutters>
                        <v-col cols="6">
                          <div class="col-12 pa-0 font-weight-bold">Fecha de inicio</div>
                          <div class="col-12 pa-0 pr-2">
                            <v-menu
                                    v-model="healthAlertPicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="formattedHealthAlertDate"
                                        append-icon="mdi-calendar-blank"
                                        :rules="genericRules"
                                        outlined
                                        hide-details
                                        dense
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                              </template>
                              <!--:allowed-dates="allowedReproductiveStagesDates"-->
                              <v-date-picker
                                      v-model="healthAlert.date"
                                      no-title
                                      @input="gestationAlertPicker = false"
                                      locale="es-419">
                              </v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                        <v-col cols="6" v-if="healthAlert.type === 'diet'">
                          <div class="col-12 pa-0 font-weight-bold">Razón de cambio</div>
                          <div class="col-12 pa-0">
                            <v-select dense
                                      hide-details
                                      :items="diets"
                                      class="alerts-autocomplete-birth"
                                      v-model="healthAlert.dietReason"
                                      placeholder="Selecciona"
                                      outlined>
                            </v-select>
                          </div>
                        </v-col>
                        <v-col cols="6" v-if="healthAlert.type === 'hltr'">
                          <div class="col-12 pa-0 font-weight-bold">Tipo de tratamiento</div>
                          <div class="col-12 pa-0">
                            <v-select dense
                                      hide-details
                                      class="alerts-autocomplete-birth"
                                      :items="treatmentTypes"
                                      v-model="healthAlert.treatment.type"
                                      placeholder="Selecciona"
                                      outlined>
                            </v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12"
                           class="d-flex flex-wrap mb-4">
                      <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                      <v-textarea
                              class="form-text-input"
                              outlined
                              placeholder="Dame una descripción"
                              v-model="healthAlert.description"
                              required>
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row no-gutters
                         v-if="sickOrAccident">
                    <v-col cols="12"
                           v-if="healthAlert.type === 'sick' || healthAlert.type === 'chg'"
                           class="mb-4">
                      <v-row no-gutters justify="center">
                        <v-col cols="6">
                          <v-select v-if="!this.healthActive"
                                    v-model="healthAlert.treatment.sick"
                                    :items="sicks"
                                    hide-details
                                    dense
                                    :placeholder="sicks[0]"
                                    outlined>
                          </v-select>
                          <div v-else
                               class="std-text-lg-open std-text-gray-3 text-center">{{currentSick}}
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12"
                           class="d-flex flex-wrap mb-4">
                      <div class="col-12 pa-0 font-weight-bold">Descripción</div>
                      <v-text-field
                              outlined
                              hide-details
                              dense
                              placeholder="Dame una descripción"
                              v-model="healthAlert.description"
                              required>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12"
                           class="mb-4">
                      <v-row no-gutters>
                        <v-col cols="6">
                          <div class="col-12 pa-0 font-weight-bold">Tipo de tratamiento</div>
                          <div class="col-12 pa-0 pr-2">
                            <v-select
                                    class="alerts-autocomplete-birth"
                                    hide-details
                                    dense
                                    v-model="healthAlert.treatment.type"
                                    :items="treatmentTypes"
                                    placeholder="Selecciona"
                                    outlined
                            ></v-select>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="col-12 pa-0 font-weight-bold">Fecha de diagnóstico</div>
                          <div class="col-12 pa-0">
                            <v-menu
                                    v-model="healthAlertPicker"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    max-width="290px"
                                    min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="formattedHealthAlertDate"
                                        append-icon="mdi-calendar-blank"
                                        :rules="genericRules"
                                        hide-details
                                        dense
                                        outlined
                                        readonly
                                        v-on="on"
                                ></v-text-field>
                              </template>
                              <!--:allowed-dates="allowedReproductiveStagesDates"-->
                              <v-date-picker
                                      v-model="healthAlert.date"
                                      no-title
                                      @input="healthAlertPicker = false"
                                      locale="es-419">
                              </v-date-picker>
                            </v-menu>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12"
                           class="mb-4">
                      <v-row no-gutters>
                        <v-col cols="6">
                          <div class="col-12 pa-0 font-weight-bold">Tipo de medicamento</div>
                          <div class="col-12 pa-0 pr-2">
                            <v-select
                                    class="alerts-autocomplete-birth"
                                    hide-details
                                    dense
                                    v-model="healthAlert.treatment.med"
                                    :items="medPresentation"
                                    placeholder="Selecciona"
                                    outlined
                            ></v-select>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="col-12 pa-0 font-weight-bold">Duración de tratamiento</div>
                          <div class="col-12 pa-0">
                            <v-select
                                    class="alerts-autocomplete-birth"
                                    hide-details
                                    dense
                                    v-model="healthAlert.treatment.duration"
                                    :items="treatmentTime"
                                    placeholder="5 días"
                                    outlined
                            ></v-select>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12"
                           class="mb-4">
                      <div class="col-12 pa-0 font-weight-bold">Tiempo fuera de producción</div>
                      <v-select
                              class="alerts-autocomplete-birth"
                              hide-details
                              dense
                              v-model="healthAlert.treatment.outProd"
                              :items="outTime"
                              placeholder="21 días"
                              outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters
                         justify="space-between">
                    <v-col cols="3"
                           @click="healthStep--">
                      <BackButton>
                      </BackButton>
                    </v-col>
                    <v-col cols="4"
                           @click="dispatchHealth()">
                      <WarnButton text="Registrar evento"
                                  color="#65D9AC">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de registro accidente, enfermedad (pantalla 2) -->
          </v-stepper-items>
        </v-stepper>
        <!-- fin de alerta de salud -->

        <!-- inicio de evento de baja -->
        <v-stepper v-model="deleteStep"
                   v-if="flagDelete">
          <v-stepper-header class="Alerts-stepperHeader">
            <v-stepper-step :complete="deleteStep> 1" step="1"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="deleteStep > 2" step="2"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items class="std-text-md">
            <!-- inicio de confirmación (pantalla 1) -->
            <v-stepper-content step="1">
              <v-row no-gutters class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> se dará de baja.</div>
                  <div class="col-12 pa-0">¿Estás seguro de hacer esto?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="closeDialog()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4" @click="nextDeleteStep()">
                  <WarnButton text="Continuar baja"></WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de dialog 1 -->

            <!-- inicio de dialog 2 -->
            <v-stepper-content step="2">
              <v-alert prominent
                       dismissible
                       tile
                       transition="scale-transition"
                       :value="delErr"
                       type="error">
                <v-row align="center">
                  <v-col class="grow">¡Hey, selecciona al menos una razón de baja antes de continuar!</v-col>
                </v-row>
              </v-alert>
              <v-row no-gutters class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> se dará de baja.</div>
                  <div class="col-12 pa-0">Selecciona la razón de baja de este animal</div>
                  <div class="col-8">
                    <v-autocomplete
                            class="alerts-autocomplete-birth"
                            dense
                            hide-details
                            v-model="deleteAlert.reason"
                            :items="deleteReasons"
                            outlined
                    ></v-autocomplete>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="backTwoDel()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4" @click="nextTwoDel()">
                  <WarnButton text="Continuar baja"></WarnButton>
                </v-col>
              </v-row>
              <!-- fin de pantalla 2 -->
            </v-stepper-content>
            <!-- fin de dialog 2 -->

            <!-- inicio de dialog 3 -->
            <v-stepper-content step="3">

              <!-- inicio baja definitiva -->
              <v-row no-gutters
                     class="mb-6"
                     v-if="deleteAlert.reason === 'Error al registrar'">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-2 std-text-red-1">La vaca <b>{{id}}</b> se eliminará por completo del sistema y quizá no puedas recuperarla.</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     v-if="deleteAlert.reason === 'Error al registrar'"
                     justify="space-between">
                <v-col cols="3"
                       @click="backThreeDel()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4"
                       @click="dispatchDelete(false)">
                  <WarnButton text="Continuar baja">
                  </WarnButton>
                </v-col>
              </v-row>
              <!-- fin baja definitiva -->

              <!--  inicio baja temporal -->
              <v-row no-gutters
                     justify="space-between"
                     v-if="deleteAlert.reason !== 'Error al registrar'">
                <v-col cols="5">
                  <v-img src="../assets/alert/cow-delete-image.svg"
                         height="300px" contain>
                  </v-img>
                </v-col>
                <v-col cols="6"
                       class="px-2"
                       style="height: 300px; position: relative">
                  <v-row no-gutters>
                    <v-col cols="12"
                           class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                      <div class="font-weight-bold col-12 pa-0 mb-6">Baja de ganado</div>
                      <div class="col-12 pa-0 mb-6">{{ reasonDescription }}</div>
                      <div class="col-12 pa-0 std-text-lg">La vaca <b>{{id}}</b> se dará de baja por <b>{{ reasonSelected }}</b></div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters
                         class="pr-2"
                         style="position: absolute; bottom: 0; left: 0; width: 100%"
                         justify="space-between">
                    <v-col cols="5" @click="backThreeDel()">
                      <BackButton></BackButton>
                    </v-col>
                    <v-col cols="5" @click="dispatchDelete(true)">
                      <WarnButton text="Registrar baja">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de dialog 3 -->
          </v-stepper-items>
        </v-stepper>
        <!-- fin de evento de baja -->

        <!-- inicio de borrado de evento -->
        <v-stepper v-model="deleteStep"
                   v-if="fEvtDelete">
          <v-stepper-header class="Alerts-stepperHeader">
            <v-stepper-step :complete="deleteStep> 1"
                            step="1"></v-stepper-step>
          </v-stepper-header>

          <v-stepper-items class="std-text-md">
            <!-- inicio de confirmación (pantalla 1) -->
            <v-stepper-content step="1">
              <v-row no-gutters class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Eliminación de evento</div>
                  <div class="col-12 pa-0 mb-2">Vamos a eliminar este evento, una vez borrado no lo podrás recuperar.</div>
                  <div class="col-12 pa-0">¿Estás seguro de hacer esto?</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3"
                       @click="closeDialog()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4"
                       @click="busEvtDelete()">
                  <WarnButton text="Eliminar"></WarnButton>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de dialog 1 -->

            <!-- inicio de dialog 2 -->
            <v-stepper-content step="2">
              <v-alert prominent
                       dismissible
                       tile
                       transition="scale-transition"
                       :value="delErr"
                       type="error">
                <v-row align="center">
                  <v-col class="grow">¡Hey, selecciona al menos una razón de baja antes de continuar!</v-col>
                </v-row>
              </v-alert>
              <v-row no-gutters class="mb-6">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> se dará de baja.</div>
                  <div class="col-12 pa-0">Selecciona la razón de baja de este animal</div>
                  <div class="col-8">
                    <v-autocomplete
                            class="alerts-autocomplete-birth"
                            dense
                            hide-details
                            v-model="deleteAlert.reason"
                            :items="deleteReasons"
                            outlined
                    ></v-autocomplete>
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     justify="space-between">
                <v-col cols="3" @click="backTwoDel()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4" @click="nextTwoDel()">
                  <WarnButton text="Continuar baja"></WarnButton>
                </v-col>
              </v-row>
              <!-- fin de pantalla 2 -->
            </v-stepper-content>
            <!-- fin de dialog 2 -->

            <!-- inicio de dialog 3 -->
            <v-stepper-content step="3">

              <!-- inicio baja definitiva -->
              <v-row no-gutters
                     class="mb-6"
                     v-if="deleteAlert.reason === 'Error al registrar'">
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-2 std-text-red-1">La vaca <b>{{id}}</b> se eliminará por completo del sistema y quizá no puedas recuperarla.</div>
                </v-col>
              </v-row>
              <v-row no-gutters
                     class="px-2"
                     v-if="deleteAlert.reason === 'Error al registrar'"
                     justify="space-between">
                <v-col cols="3"
                       @click="backThreeDel()">
                  <BackButton></BackButton>
                </v-col>
                <v-col cols="4"
                       @click="dispatchDelete(false)">
                  <WarnButton text="Continuar baja">
                  </WarnButton>
                </v-col>
              </v-row>
              <!-- fin baja definitiva -->

              <!--  inicio baja temporal -->
              <v-row no-gutters
                     justify="space-between"
                     v-if="deleteAlert.reason !== 'Error al registrar'">
                <v-col cols="5">
                  <v-img src="../assets/alert/cow-delete-image.svg"
                         height="300px" contain>
                  </v-img>
                </v-col>
                <v-col cols="6"
                       class="px-2"
                       style="height: 300px; position: relative">
                  <v-row no-gutters>
                    <v-col cols="12"
                           class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                      <div class="font-weight-bold col-12 pa-0 mb-6">Baja de ganado</div>
                      <div class="col-12 pa-0 mb-6">{{ reasonDescription }}</div>
                      <div class="col-12 pa-0 std-text-lg">La vaca <b>{{id}}</b> se dará de baja por <b>{{ reasonSelected }}</b></div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters
                         class="pr-2"
                         style="position: absolute; bottom: 0; left: 0; width: 100%"
                         justify="space-between">
                    <v-col cols="5" @click="backThreeDel()">
                      <BackButton></BackButton>
                    </v-col>
                    <v-col cols="5" @click="dispatchDelete(true)">
                      <WarnButton text="Registrar baja">
                      </WarnButton>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-stepper-content>
            <!-- fin de dialog 3 -->
          </v-stepper-items>
        </v-stepper>
        <!-- fin de borrado de evento -->
      </v-dialog>

      <!-- inicio pantalla para registro de toro -->
      <v-dialog v-model="bullDialog"
                width="35%">
        <v-row no-gutters class="pl-6 pr-8 std-background-white-1">
          <v-col cols="12"
                 class="std-text-md  d-flex flex-wrap std-text-blue-2">
            <div class="col-12 text-center mt-3 mb-2 pa-0 font-weight-bold">Registro de toro</div>
            <div class="col-12 text-center mb-4 font-weight-bold std-text-sm pa-0">
              Toro utilizado para inseminación o monta
            </div>
            <div class="col-12 pa-0 d-flex flex-wrap mb-2">
              <div class="col-12 pa-0">Identificador interno</div>
              <v-text-field
                      v-model="bull.id"
                      clearable
                      hide-details
                      dense
                      class="font-weight-regular"
                      outlined
                      placeholder="1234"
                      required
                      :rules="idRules">
              </v-text-field>
            </div>
            <div class="col-12 pa-0 d-flex flex-wrap mb-2">
              <div class="col-12 pa-0">Raza</div>
              <v-select
                      v-model="bull.breed"
                      :items="breeds"
                      class="font-weight-regular"
                      placeholder="Holstein"
                      outlined
                      hide-details
                      dense
                      required
                      :rules="genericRules"
              ></v-select>
            </div>
            <div class="col-12 pa-0 d-flex flex-wrap mb-2">
              <div class="col-12 pa-0">Fecha de nacimiento</div>
              <v-menu
                      v-model="birthdayPicker"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                          :value="formattedBirthday"
                          append-icon="mdi-calendar-blank"
                          outlined
                          dense
                          hide-details
                          placeholder="DD/MM/AAAA"
                          readonly
                          required
                          :rules="genericRules"
                          v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                        :key="birthdayKey"
                        v-model="bull.birthday"
                        :allowed-dates="allowedBirthdayDates"
                        no-title
                        @input="birthdayPicker = false"
                        locale="es-419"></v-date-picker>
              </v-menu>
            </div>
            <div class="col-12 pa-0 d-flex flex-wrap mb-8">
              <div class="col-12 pa-0">ID SINIIGA</div>
              <v-text-field
                      clearable
                      dense
                      hide-details
                      outlined
                      placeholder="MX-00-AGS(01)-0000-0000"
                      required
                      v-model="bull.idSiniiga"
                      :rules="idRules">
              </v-text-field>
            </div>
            <v-row no-gutters
                   class="mb-4"
                   justify="space-between">
              <v-col cols="5"
                     @click="resetBullData">
                <BackButton>
                </BackButton>
              </v-col>
              <v-col cols="5">
                <WarnButton text="Registrar"
                            color="#65D9AC">
                </WarnButton>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-dialog>
      <!-- fin pantalla para registro de toro -->
    </v-row>
  </v-container>

</template>

<script>
    import { EventBus } from './bus';
    import BackButton from "../components/BackButton";
    import moment from 'moment';
    import WarnButton from "../components/WarnButton";
    export default {
        name: 'Alerts',
        props: ['heatNtn', 'ptCheck', 'pregnantAlertConfirmed', 'id', 'animalKey', 'healthAct', 'currentSick'],
        data() {
            return {
                genericRules: [
                    v => !!v || 'Campo Requerido',
                    v => (v.length > 0) || "Información no valida",
                ],
                alertDatePicker: false,
                widthDialog: '40%',
                alertDate: moment().format('YYYY-MM-DD'),
                gestationAlertPicker: false,
                healthAlertPicker: false,
                flagHeat: false, // variable que controla el dialog de celo
                flagGestation: false, // variable que controla el dialog de gestación
                flagBirth: false, // variable que controla el dialog de parto
                flagInsemination: false, // variable auxiliar para controlar el dialog de celo
                flagSick: false, // variable que controla el dialog de enfermedad
                flagDelete: false, // variable que controla el dialog de borrado de animal
                fEvtDelete: false,
                healthActive: this.healthAct,
                heatAlertComplete: false, // permite sabe si la alerta de celo ha sido completada por el usuario
                pregnantAlertComplete: false, // permite saber si la alerta de parto ha sido completada por el usuario
                birthAlertComplete: false, // permite saber si la alerta de parto ha sido completada por el usuario
                cleanHeat: false,
                dialogHeat: false, // permite cerrar el dialog de alerta de celo
                heatStep: 1, // controla los pasos del dialog del registro de celo
                healthStep: 1, // controla los pasos del dialog del registro de enfermedad
                gestationStep: 1, // controla los pasos del dialog de gestación
                deleteStep: 1, // controla los pasos del dialog de borrado de animal
                checkDiet: false,
                items: ['foo', 'bar', 'fizz', 'buzz'],
                checkGroup: false,
                birthStep: 1,
                dateKey: 0,
                flagNotHeat: false,
                sickCase: 'accident',
                birthCase: 'accident',
                heatAlert: {
                    confirmed: false,
                    clean: false,
                    treatment: {
                        applied: false,
                        type: null,
                    },
                    inseminated: false,
                    waiting: false,
                    description: '',
                    heat: false,
                    bull: null,
                    key: '',
                    date: moment().format('YYYY-MM-DD')
                },
                gestationAlert: {
                    isPregnant: false,
                    description: '',
                    group: '',
                    diet: '',
                    method: '',
                    date: moment().format('YYYY-MM-DD')

                },
                birthAlert: {
                    abort: false,
                    time: 'atTime',
                    description: '',
                    diagnostic: '',
                    abortSick: '',
                    abortType: null,
                    abortReason: '',
                    date: moment().format('YYYY-MM-DD')
                },
                healthAlert: {
                    type: 'acc',
                    description: '',
                    date: moment().format('YYYY-MM-DD'),
                    treatment: {
                        type: '',
                        sick: '',
                        med: '',
                        duration: '',
                        outProd: '',
                    },
                    dietReason: '',
                },
                deleteAlert: {
                  reason: 'Error al registrar',
                },
                evtAlert: '',
                alertDialog: false,
                bullDialog: false,
                healthEvent: '',
                idRules: [
                    v => 'El número de identificación es requerido',
                    v => /^[A-Za-z0-9]*$/.test(v) || 'Asegúrate que sean sólo números y letras',
                ],
                bull: {
                    id: '',
                    birthday: '',
                    breed: '',
                    idSiniiga: '',
                },
                breeds: ['Holstein', 'Jersey', 'Simmental', 'Pardo Suizo', 'Guernsev', 'Ayrshire', 'Shorthorn', 'Normando Frances', 'Otra raza'], // razas del animal
                birthdayPicker: false, // selector del calendario de fecha de nacimiento
                birthdayKey: 0,
                bullFormIndex: 0,
                abortCauses: ['Hormonal', 'Reabsorción embrionaria', 'Nutrición', 'Otro'],
                abortSicks: ['Intoxicación nutricional', 'Virus', 'Bacteria', 'Tratamiento por enfermedad'],
                treatmentTypes: ['Antibiótico', 'Antiséptico', 'Antibacteriano', 'Antimicótico', 'Quirúrgico', 'Antiinflamatorio', 'Corticoide'],
                medPresentation: ['En piel o tópico', 'Oral o tableta', 'Inyección'],
                treatmentTime: ['3 días', '5 días', '7 días', '10 días'],
                outTime: ['7 días', '14 días', '21 días'],
                diets: ['Etapa reproductiva', 'Enfermedad', 'Tratamiento médico', 'Otra'],
                sicks: ['Mastitis', 'Brucelosis', 'Pulmonía', 'Cetosis', 'Tuberculosis', 'Cojera', 'Fiebre aftosa', 'Envenenamiento', 'Otra'],
                deleteReasons: ['Error al registrar', 'Venta a rastro', 'Venta a otro rancho', 'Muerte (Registro de deshecho)'],
                indexMax: 0,
                delErr: false,
            }
        },
        watch: {
            alertDialog(newValue) {
                this.heatStep = 1;
                this.resetHeatAlert();
                this.resetPregnantAlert();
                this.resetBirthAlert();
                this.resetHealthAlert();
                this.resetDeleteAlert();

                if (!newValue && !this.heatAlertComplete && this.flagHeat) {
                    let evntCancel = {
                        evnt: 'ht',
                        ntn: this.heatNtn
                    };
                    EventBus.$emit('evntIncomplete', evntCancel);
                } else if (!newValue && !this.pregnantAlertComplete && this.flagGestation) {
                    let evntCancel = {
                        evnt: 'ht',
                        ntn: this.ptCheck
                    };
                    EventBus.$emit('evntIncomplete', evntCancel);
                } else if (!newValue && !this.birthAlertComplete && this.flagBirth) {
                    EventBus.$emit('birthOff');
                }
            },
            abortType(newAbortType) {
                if (newAbortType === 'natural') {
                    this.birthAlert.abortReason = null;
                } else if (newAbortType === 'ind') {
                    this.birthAlert.abortReason = null;
                }
            },
        },
        components: {
            WarnButton,
            BackButton
        },
        computed: {
            /**
             * Description of first screen in the heat alert
             */
            htSub() {
                if (this.heatNtn) {
                    return `La vaca <b> ${this.id} </b> está dentro de los días estimados para el celo.`;
                } else {
                    return `La vaca <b> ${this.id} </b> no está dentro de los días estimados para el celo,
                            sin embargo puedes registrarlo si lo deseas.`;
                }
            },
            /**
             * Description of first screen in the pregnant alert
             */
            ptSub() {
                if (this.ptCheck) {
                    return `Parece ser que la vaca <b>${this.id}</b> ya se encuentra preñada, sin embargo puedes registrar
                            un nuevo evento que borrará automáticamente el evento previo.`;
                } else {
                    return `La vaca <b>${this.id}</b> está dentro de los días estimados para diagnóstico de gestación.`;
                }
            },
            reasonDescription() {
                switch(this.deleteAlert.reason) {
                    case 'Venta a rastro':
                        return 'Vamos a extrañar a este animal, pero en fin... ¿Se va a hacer o no se va a hacer? ¡La carnita asada!';
                    case 'Venta a otro rancho':
                        return '¡Esperemos que su nuevo dueño la cuide tan bien como tú!'
                    case 'Muerte (Registro de deshecho)':
                        return '¡Lamentamos tu pérdida! Esperemos que tus otras vacas no se pongan tristes por su partida.'
                    default:
                        return '';
                }
            },
            reasonSelected() {
                return this.deleteAlert.reason.toLowerCase();
            },
            healthType() {
                return this.healthAlert.type;
            },
            abortType() {
                return this.birthAlert.abortType;
            },
            abortReason() {
              return this.birthAlert.abortReason;
            },
            /**
             * Regresa el grupo del animal actual
             */
            group() {
                return this.$store.getters.getCurrentAnimal.group;
            },
            groups() {
                return "";
            },
            currentAnimal() {
                return this.$store.getters.getCurrentAnimal;
            },
            /**
             * Regresa la fecha nacimiento del animal en formato día - mes - año
             */
            formattedBirthday() {
                return this.bull.birthday ? moment(this.bull.birthday).format('DD [de] MMMM [del] YYYY') : '';
            },
            bulls() {
              return this.$store.getters.getBulls;
            },
            birthTimeButton() {
                let result = '';
                if (this.birthAlert.time === 'before') {
                    result =  `Sí, <b>anticipado</b>`;
                } else if (this.birthAlert.time === 'atTime') {
                    result =  `Sí, <b>dentro</b> lo esperado`;
                } else if (this.birthAlert.time === 'after') {
                    result =  `Sí, <b>retrasado</b>`;
                }
                return result;
            },
            formattedDate() {
                return moment(this.alertDate).format('DD [de] MMMM [del] YYYY');
            },
            formattedGestationAlertDate() {
                return this.gestationStep === 3 ? moment(this.gestationAlert.date).format('DD [de] MMMM [del] YYYY') : '';
            },
            formattedBirthAlertDate() {
                return this.birthStep === 2 ? moment(this.birthAlert.date).format('DD [de] MMMM [del] YYYY') : '';
            },
            formattedHealthAlertDate() {
                return this.healthStep === 2 ? moment(this.healthAlert.date).format('DD [de] MMMM [del] YYYY') : '';
            },
            heatDescription() {
                let result = '';
                if (this.flagNotHeat) {
                    result = 'Se observó que la vaca no entró en celo en el periodo esperado.';
                } else {
                    if (this.heatAlert.inseminated && this.heatAlert.clean && this.heatAlert.confirmed && this.heatStep >= 3) {
                        result = 'Se observó que entrara en celo en el periodo esperado, el celo fue limpio y se inseminó ' +
                            'a la vaca.';
                    } else if (this.heatAlert.inseminated && this.heatStep >= 3) {
                        result = 'Se observó que entrara en celo en el periodo esperado, el celo fue limpio y se inseminó ' +
                            'a la vaca.';
                    } else if (this.heatAlert.confirmed && !this.heatAlert.inseminated && !this.heatAlert.clean
                        && !this.heatAlert.waiting && this.heatAlert.treatment && this.heatStep > 4) {
                        result = 'Se observó que entrara en celo en el periodo esperado, pero el celo fue sucio. Se le aplicó el ' +
                            'tratamiento correspondiente.';
                    } else if (this.heatAlert.confirmed && !this.heatAlert.inseminated && !this.heatAlert.clean
                        && !this.heatAlert.waiting && !this.heatAlert.treatment && this.heatStep === 5) {
                        result = 'Se observó que entrara en celo en el periodo esperado, pero el celo fue sucio. Se decidió no dar ' +
                            'medicación.';
                    } else if (this.heatAlert.confirmed && !this.heatAlert.inseminated && this.heatAlert.clean
                        && this.heatAlert.waiting && !this.heatAlert.treatment && this.heatStep === 5) {
                        result = 'Se observó que entrara en celo en el periodo esperado, el celo fue limpio y no se inseminó a la  ' +
                            'vaca debido a que está en tiempo de espera.';
                    }
                }
                return result;
            },
            gestationDescription: {
                get() {
                    let result = '';
                    if (this.gestationAlert.method === 'touch' && this.gestationAlert.isPregnant && this.gestationStep === 3) {
                        result = 'Se diagnosticó por tacto que la concepción fue exitosa.';
                    } else if (this.gestationAlert.method === 'touch' && !this.gestationAlert.isPregnant && this.gestationStep === 3) {
                        result = 'Se diagnosticó por tacto que la concepción no fue exitosa.';
                    } else if (this.gestationAlert.method === 'ultrasound' && this.gestationAlert.isPregnant && this.gestationStep === 3) {
                        result = 'Se diagnosticó por ultrasonido que la concepción fue exitosa.';
                    } else if (this.gestationAlert.method === 'ultrasound' && !this.gestationAlert.isPregnant && this.gestationStep === 3) {
                        result = 'Se diagnosticó por ultrasonido que la concepción no fue exitosa.';
                    }
                    return result;
                },
                set(newDescription) {
                    this.gestationAlert.description = newDescription;
                    return newDescription;
                }
            },
            birthDiagnostic: {
                get() {
                    let diagnostic = '';
                    if (this.birthAlert.abort && this.birthAlert.time === 'before' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>anticipado</b>.`;
                    } else if (this.birthAlert.abort && this.birthAlert.time === 'atTime' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>esperado</b>.`;
                    } else if (this.birthAlert.abort && this.birthAlert.time === 'after' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>retrasado</b>.`;
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'before' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>anticipado</b>.`;
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'atTime' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>esperado</b>.`;
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'after' && this.birthStep === 2) {
                        diagnostic = `Parto exitoso <b>retrasado</b>.`;
                    }
                    return diagnostic;
                },
            },
            birthDescription: {
                get() {
                    let description = '';
                    if (this.birthAlert.abort && this.abortType === 'ind' && this.abortReason === 'acc' && this.birthStep === 2) {
                        description = 'Se diagnóstico un aborto inducido por accidente';
                    } else if (this.birthAlert.abort && this.abortType === 'ind' && this.abortReason === 'sick' && this.birthStep === 2) {
                        description = 'Se diagnóstico un aborto inducido por enfermedad';
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'before' && this.birthStep === 2) {
                        description = 'La vaca entró en labor de parto antes de la fecha esperada.';
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'atTime' && this.birthStep === 2) {
                        description = 'La vaca entró en labor de parto dentro de la fecha esperada.';
                    } else if (!this.birthAlert.abort && this.birthAlert.time === 'after' && this.birthStep === 2) {
                        description = 'La vaca entró en labor de parto después de la fecha esperada.';
                    }
                    return description;
                },
                set(newDescription) {
                    this.birthAlert.description = newDescription;
                }
            },
            clean() {
                let result = 'no';
                if (this.heatStep.clean) {
                    result = 'yes';
                }
                return result;
            },
            inseminated() {
                let result = 'no';
                if (this.heatStep.inseminated) {
                    result = 'yes';
                }
                return result;
            },
            caseInseminated() {
                return this.heatAlert.confirmed && this.heatAlert.inseminated && this.heatAlert.clean
                    && !this.heatAlert.waiting && !this.heatAlert.treatment.applied && this.heatStep === 5;
            },
            caseAlert() {
                return this.heatAlert.confirmed && !this.heatAlert.inseminated && this.heatAlert.clean
                    && !this.heatAlert.waiting && !this.heatAlert.treatment.applied && this.heatStep === 5;
            },
            caseDirtyMed() {
                return this.heatAlert.confirmed && !this.heatAlert.inseminated && !this.heatAlert.clean
                    && !this.heatAlert.waiting && this.heatAlert.treatment.applied && this.heatStep === 5;
            },
            caseDirtyWMed() {
                return !this.flagNotHeat && this.heatAlert.confirmed && !this.heatAlert.inseminated && !this.heatAlert.clean
                    && !this.heatAlert.waiting && !this.heatAlert.treatment.applied && this.heatStep === 5;
            },
            casePEVFStep() {
                return this.heatAlert.confirmed && !this.heatAlert.inseminated.applied && this.heatAlert.clean
                    && this.heatStep === 4;
            },
            casePEV() {
                return this.heatAlert.confirmed && !this.heatAlert.inseminated && this.heatAlert.clean
                    && this.heatAlert.waiting && !this.heatAlert.treatment.applied && this.heatStep === 5;
            },
            caseTouchSuccess() {
                return this.gestationAlert.method === 'touch' && this.gestationAlert.isPregnant;
            },
            caseTouchNot() {
                return this.gestationAlert.method === 'touch' && !this.gestationAlert.isPregnant && this.gestationStep === 3;
            },
            caseUltraSuccess() {
                return this.gestationAlert.method === 'ultrasound' && this.gestationAlert.isPregnant && this.gestationStep === 3;
            },
            caseUltraNot() {
                return this.gestationAlert.method === 'ultrasound' && !this.gestationAlert.isPregnant && this.gestationStep === 3;
            },
            caseAbort() {
              return this.birthAlert.abort && this.birthStep === 2;
            },
            caseBirth() {
                return !this.birthAlert.abort && this.birthStep === 2;
            },
            sickOrAccident() {
                let type = this.healthAlert.type
                return type === 'sick' || type === 'acc' || type === 'chg';
            },
            dietTreatment() {
                return this.healthAlert.type === 'hltr' || this.healthAlert.type === 'diet';
            },
            dietTreatmentAuto() {
                let result = '';
                if (this.healthAlert.type === 'treatment') {
                    result = 'Tipo de tratamiento';
                } else if (this.healthAlert.type === 'diet') {
                    result = 'Razón de cambio';
                }
                return result;
            },
            healthTitle() {
                let result = '';
                switch (this.healthAlert.type) {
                    case 'acc':
                        result = 'Registro de accidente';
                        break;
                    case 'sick':
                        result = 'Registro de enfermedad y diagnóstico';
                        break;
                    case 'diet':
                        result = 'Registro de cambio de dieta';
                        break;
                    case 'hltr':
                        result = 'Registro de tratamiento médico';
                        break;
                    default:
                        break;
                }
                return result;
            }
        },
        methods: {
            abortTypeSet(type) {
                this.birthAlert.abortType = type;
            },
            busEvtDelete() {
              EventBus.$emit('evtDelete');
                this.alertDialog = false;
            },
            getPregName() {
              if (this.gestationAlert.isPregnant) {
                  return 'Concepción exitosa';
              }  else {
                  return 'Concepción no exitosa';
              }
            },
            healthTypeSet(type){
                console.log(type);
              this.healthAlert.type = type;
            },
            abortReasonSet(type){
                this.birthAlert.abortReason = type;
            },
            healthSuccess() {
                if (this.healthAlert.type === 'scs') {
                    this.dispatchHealth();
                } else {
                    this.healthStep = 2;
                }
            },
            restartAlerts() {
                this.heatStep = 0;
                this.heatAlert = {
                    userConfirmed: '',
                    clean: '',
                    treatment: '',
                    insemination: '',
                    waitingTime: '',
                    description: '',
                    date: ''
                };
                this.newAlertGestation = {
                    confirmationMethod: '',
                    confirmationGestation: ''
                };
                this.birthAlert = {
                    confirmationBirth: '',
                    lateBirth: ''
                };
                this.alertDialog = false;
                this.flagHeat = false;
                this.flagSick = false;
                this.gestationAlert = false;
                this.flagBirth = false;
                EventBus.$emit('closeAlerts');

            },
            nextDeleteStep() {
                this.deleteStep += 1;
            },
            closeDialog() {
                this.alertDialog = false;
            },
            notHeat() {
                this.heatStep = 5;
                this.flagNotHeat = true;
                this.heatAlert = {
                    userConfirmed: true,
                    clean: false,
                    treatment: false,
                    isInHeat: false,
                    insemination: false,
                    waitingTime: false,
                    bull: null,
                    description: '',
                    date: moment().format('YYYY-MM-DD'),
                };
            },
            /**
             * Método que da funcionalidad al botón confirmar en el paso 1
             * de el registro de celo
             */
            confirmHeat() {
                this.heatStep = 2;
                this.heatAlert.confirmed = true;
            },
            /**
             * Método que registra si el celo fue limpio o no
             * @param clean
             */
            isClean(clean) {
                this.heatStep = 3;
                this.heatAlert.clean = clean;
            },
            wasInseminated(inseminated) {
                this.heatStep = inseminated ? 5 : 4;
                this.heatAlert.inseminated = inseminated;
            },
            wasPEV(waitingTime) {
                this.heatStep++;
                this.heatAlert.waiting = waitingTime;
            },
            /**
             * Cambia
             */
            wasTreatment(treatment) {
                this.heatStep += 2;
                this.heatAlert.treatment.applied = treatment;
            },
            wasPregnant(pregnant) {
                this.gestationStep++;
                this.gestationAlert.isPregnant = pregnant;
            },
            /**
             * Reinicia todos los parámetros de pregnantAlert
             * además de regresar el stepper al primer paso
             */
            resetPregnantAlert() {
              this.gestationStep = 1;
              this.checkGroup = false;
              this.checkDiet = false;
              this.gestationAlert =  {
                  isPregnant: false,
                  method: '',
                  group: '',
                  description: '',
                  diet: '',
                  date: moment().format('YYYY-MM-DD')
                }
            },
            resetBullData() {
                this.bullDialog = false;
                this.bullFormIndex++;
                this.bull = {
                    id: '',
                    birthday: '',
                    breed: '',
                    idSiniiga: '',
                }
            },
            wasAbort(abort) {
                this.birthStep++;
                this.birthAlert.abort = abort;
            },
            /**
             * Reinicia todos los parámetros de birthAlert
             * además de regresar el stepper al primer paso
             */
            resetBirthAlert() {
                this.birthStep = 1;
                this.birthAlert = {
                    abort: false,
                    time: 'atTime',
                    diagnostic: '',
                    description: '',
                    abortType: null,
                    abortSick: '',
                    abortReason: '',
                    date: moment().format('YYYY-MM-DD')
                };
            },
            /**
             * Go back from two screen of delete flux
             */
            backTwoDel() {
                this.deleteStep = 1;
            },
            /**
             * Go back from three screen of delete flux
             */
            backThreeDel() {
                this.deleteStep = 2;
                this.widthDialog = '40%';
                this.delErr = false;
            },
            /**
             * Go forward from two screen of delete flux
             */
            nextTwoDel() {
                // shows a briefly notification
                if (this.deleteAlert.reason === '') {
                    this.delErr = true;
                    setTimeout(() => {
                        this.delErr = false;
                    }, 2000);
                } else {
                    if (this.deleteAlert.reason !== 'Error al registrar') {
                        this.widthDialog = '60%';
                    } else {
                        this.widthDialog = '40%';
                    }
                    this.deleteStep++;
                }
            },
            /**
             * Método para el botón regresar desde la segunda pantalla de la
             * alerta de preñez.
             */
            backFromTwoPregnant() {
                this.gestationStep--;
                this.gestationAlert.isPregnant = false;
            },
            /**
             * Método para el botón regresar desde la tercera pantalla de la
             * alerta de preñez.
             */
            backFromThreePregnant() {
                this.gestationStep--;
                this.gestationAlert.description = '';
                this.gestationAlert.method = '';
            },
            backFromTwoBirth() {
              this.birthStep--;
              this.birthAlert.abortType = null;
              this.birthAlert.abortReason = '';
              this.birthAlert.abort = false;
            },
            whichMethodGestation(method) {
                console.log("wich!!!!!")
                this.gestationStep++;
                this.gestationAlert.method = method;
            },
            /**
             * Reinicia todos los parámetros de heatAlert
             * además de regresar el stepper al primer paso
             */
            resetHeatAlert() {
                this.flagNotHeat = false;
                this.heatStep = 1;
                this.heatAlert = {
                    confirmed: false,
                    clean: false,
                    treatment: {
                        applied: false,
                        type: null,
                    },
                    inseminated: false,
                    waiting: false,
                    description: '',
                    heat: false,
                    bull: null,
                    key: '',
                    date: moment().format('YYYY-MM-DD')
                }
            },
            resetHealthAlert() {
                this.healthStep = 1;
                this.healthAlert = {
                    type: 'acc',
                    description: '',
                    date: moment().format('YYYY-MM-DD'),
                    treatment: {
                      type: '',
                          sick: '',
                          med: '',
                          duration: '',
                          outProd: '',
                    },
                    dietReason: '',
                }
            },
            resetDeleteAlert() {
                this.deleteAlert =  {
                    reason: 'Error al registrar',
                };
                this.deleteStep = 1;
                this.delErr = false;
            },
            /**
             * Método para el botón regresar desde la segunda pantalla de la
             * alerta de celo.
             */
            backFromTwoHeat() {
                this.heatAlert.clean = false;
                this.heatStep--;
            },
            /**
             * Método para el botón regresar desde la tercera pantalla de la
             * alerta de celo.
             */
            backFromThreeHeat() {
                this.heatAlert.inseminated = false;
                this.heatAlert.treatment = false;
                this.heatStep--;
            },
            /**
             * Método para el botón regresar desde la cuarta pantalla de la
             * alerta de celo.
             */
            backFromFourHeat() {
                this.heatAlert.waiting = false;
                this.heatStep--;
            },
            /**
             * Dispatch an action in the store file to save a heat
             */
            dispatchHeat(typeHeat) {
                this.heatAlert.key = this.animalKey;
                this.heatAlert.typeHeat = typeHeat;
                this.heatAlertComplete = true;
                // si el usuario no introduce información, entonces toma la descripción por defecto
                if (this.heatAlert.description === '') {
                    this.heatAlert.description = this.heatDescription;
                }

                this.heatAlert.heat = typeHeat !== 1;

                this.$store.dispatch('saveHeatAlert', this.heatAlert);
                EventBus.$emit('showEvntSnack');
                EventBus.$emit('heatCompleted');
                this.alertDialog = false; // cierra el dialog de alertas
            },
            /**
             * Guarda un evento de preñado en la base de datos
             */
            dispatchPreg(type) {
                this.gestationAlert.key = this.animalKey;
                this.gestationAlert.type = type;
                this.gestationAlert.name = this.getPregName();
                this.pregnantAlertComplete = true;
                EventBus.$emit('showEvntSnack');
                this.$store.dispatch('savePregnantAlert', this.gestationAlert);
                EventBus.$emit('pregCompleted', this.gestationAlert.isPregnant);
                this.alertDialog = false;
            },
            dispatchHealth() {
                switch (this.healthAlert.type) {
                    case 'acc':
                        this.healthAlert.name = 'Accidente';
                        break;
                    case 'diet':
                        this.healthAlert.name = 'Dieta';
                        break;
                    case 'sick':
                        this.healthActive = true;
                        this.healthAlert.name = 'Enfermedad';
                        break;
                    case 'hltr':
                        this.healthAlert.name = 'Tratamiento médico';
                        break;
                    case 'chg':
                        this.healthAlert.name = 'Cambio de tratamiento';
                        this.healthAlert.treatment.sick = this.activeSick;
                        break;
                    case 'scs':
                        this.healthActive = false;
                        this.healthAlert.name = 'Tratamiento finalizado';
                        break;
                    default:
                        this.healthAlert.name = 'UK';
                        break;
                }
                EventBus.$emit('showEvntSnack');
                this.healthAlert.key = this.animalKey;
                this.$store.dispatch('saveHealthAlert', this.healthAlert);
                this.alertDialog = false;
            },
            /**
             * Saves a birth event in the database
             */
            dispatchBirth() {
                this.birthAlert.key = this.animalKey;
                let tempDiagnostic = this.birthDiagnostic;
                tempDiagnostic = tempDiagnostic.replace('<b>', '');
                tempDiagnostic = tempDiagnostic.replace('</b>', '');
                tempDiagnostic = tempDiagnostic.replace('.', '');
                this.birthAlert.diagnostic = tempDiagnostic;
                this.birthAlertComplete = true;

                EventBus.$emit('birthOn');
                EventBus.$emit('showEvntSnack');
                if (this.birthAlert.description === '') {
                    this.birthAlert.description = this.birthDescription;
                }


                this.$store.dispatch('saveBirthAlert', this.birthAlert);
                this.alertDialog = false;
            },
            /**
             * Calcula las fechas permitidas para el picker date de la fecha de nacimiento de la vaca
             * @param val fecha a revisar mediante la fecha actual
             * @returns {boolean} true si la fecha es permitida, false si no es así
             */
            allowedBirthdayDates(val) {
                // vaquilla seleccionada
                if (this.heiferSelected) {
                    // mayor a 390 dias (13 meses) y no mayor a la fecha actual
                    return moment().diff(moment(val), 'days') < 390 && (moment().diff(moment(val)) > 1);
                } else {
                    return moment().diff(moment(val)) > 1;
                }
            },
            /**
             * Dispatch an action in the store file to delete an animal
             * @param soft type of delete
             */
            dispatchDelete(soft) {
                let payload = {
                    animalType: localStorage.animalType,
                    key: this.animalKey,
                    soft: soft,
                }
                this.$store.dispatch('deleteAnimal', payload)
                this.alertDialog = false;
            },
        },
        created () {
            moment.locale('es');
            EventBus.$on('changeAlertType', (type) => {

                this.alertDialog = true;
                this.flagHeat = false;
                this.flagSick = false;
                this.flagGestation = false;
                this.flagBirth = false;
                this.flagDelete = false;
                this.fEvtDelete = false;

                switch (type) {
                    case 'Heat':
                        this.flagHeat = true;
                        this.widthDialog = '45%'
                        break;
                    case 'Gestation':
                        this.widthDialog = '45%'
                        this.flagGestation = true;
                        break;
                    case 'Birth':
                        this.widthDialog = '45%'
                        this.flagBirth = true;
                        break;
                    case 'Health':
                        this.widthDialog = '45%'
                        this.flagSick = true;
                        break;
                    case 'Delete':
                        this.widthDialog = '40%'
                        this.flagDelete = true;
                        break;
                    case 'evt':
                        this.widthDialog = '40%';
                        this.fEvtDelete = true;
                        break;
                    default:
                        break;
                }
            });
        }
    };
</script>

<style lang="css">
  @import '../style/Alerts.css';
</style>
